"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppErrorBoundary = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _DatadogErrorBoundary2 = require("./DatadogErrorBoundary");
var _LargeError = require("./LargeError");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var AppErrorBoundary = exports.AppErrorBoundary = /*#__PURE__*/function (_DatadogErrorBoundary) {
  (0, _inherits2["default"])(AppErrorBoundary, _DatadogErrorBoundary);
  var _super = _createSuper(AppErrorBoundary);
  function AppErrorBoundary(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AppErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  (0, _createClass2["default"])(AppErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return _react["default"].createElement(_LargeError.LargeError, {
          description: "There was a problem loading this page. Please try a browser refresh and if the problem persists, reach out to client support."
        });
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error('AppErrorBoundary - ', error);
      return {
        hasError: true
      };
    }
  }]);
  return AppErrorBoundary;
}(_DatadogErrorBoundary2.DatadogErrorBoundary);